export default __webpack_public_path__ + "static/media/email.64cb62a1.png";